import * as React from "react";

import { HeaderSubKind } from "../../Layout/SimpleTable/HeaderSubKind";

import { Root } from "./StickyTableHeaderRow.styles";

interface StickyTableHeaderRowProps {
    children: React.ReactNode;
    subkind?: HeaderSubKind;
    isLastTextHeaderRow?: boolean;
    showBottomBorder?: boolean;
}

export function StickyTableHeaderRow(props: StickyTableHeaderRowProps): JSX.Element {
    return (
        <Root subkind={props.subkind} isLast={props.isLastTextHeaderRow} showBottomBorder={props.showBottomBorder}>
            {props.children}
        </Root>
    );
}
